// @ts-nocheck
export default {
  data() {
    return {
      sortings: {
        ProviderGroupName: [
          undefined,
          { by: "provider-group-name", icon: "▲", direction: "asc" },
          { by: "provider-group-name", icon: "▼", direction: "desc" },
        ],
        City: [
          undefined,
          { by: "city", icon: "▲", direction: "asc" },
          { by: "city", icon: "▼", direction: "desc" },
        ],
      },
      currentSortKey: "ProviderGroupName",
      currentSortIndex: 0,
      listOrder: undefined,
    };
  },

  computed: {
    ProviderGroupNameColumnSortingIcon() {
      if (this.currentSortKey === "ProviderGroupName") {
        return (
          this.sortings.ProviderGroupName[this.currentSortIndex]?.icon || "▼▲"
        );
      }
      return "▼▲";
    },
    CityColumnSortingIcon() {
      if (this.currentSortKey === "City") {
        return this.sortings.City[this.currentSortIndex]?.icon || "▼▲";
      }
      return "▼▲";
    },
  },

  methods: {
    changeListOrder(key, callback) {
      if (this.currentSortKey === key) {
        this.updateCurrentSortingIndex(callback);
        return;
      }

      this.currentSortKey = key;
      this.currentSortIndex = 0;
      this.updateCurrentSortingIndex(callback);
    },
    updateCurrentSortingIndex(callback) {
      if (
        this.currentSortIndex ===
        this.sortings[this.currentSortKey].length - 1
      ) {
        this.currentSortIndex = 0;
        this.listOrder = this.sortings[this.currentSortKey][0];
        callback();
        return;
      }

      this.currentSortIndex++;
      this.listOrder =
        this.sortings[this.currentSortKey][this.currentSortIndex];
      return callback();
    },
  },
};
